import { render, staticRenderFns } from "./BlankIcon.vue?vue&type=template&id=0a12538a&scoped=true&"
import script from "./BlankIcon.vue?vue&type=script&lang=js&"
export * from "./BlankIcon.vue?vue&type=script&lang=js&"
import style0 from "./BlankIcon.vue?vue&type=style&index=0&id=0a12538a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a12538a",
  null
  
)

export default component.exports